<section>
  <div class="detail-card-header flex--r-c gap--8 p-l--8 p-t--4 p-b--4">
    <mat-icon style="color: white">notifications</mat-icon>
    <span whFlex class="w-h-header-span">
      <div class="single-header">
        @if (
          data.reminderOffsetInMinutes || data.reminderOffsetInMinutes === 0
        ) {
          {{ "technicianNotification.label.editNoticiation" | translate }}
        } @else {
          {{ "technicianNotification.label.createNoticiation" | translate }}
        }
      </div>
    </span>
  </div>
  <div class="remind-technician-settings-dialog-body">
    @if (remindTechnicianFormGroup.disabled) {
      <div class="messages-container flex--r-c gap--8 warn m-b--12">
        <mat-icon>warning</mat-icon>
        {{ "app.ui.remindTechnicianWarning.label" | translate }}
      </div>
    }

    @if (data.showNoneMessage) {
      <div class="messages-container flex--r-c gap--8 warn m-b--12">
        <mat-icon>warning</mat-icon>
        {{ "app.ui.noWorkOrdersMatch.label" | translate }}
      </div>
    }
    <form [formGroup]="remindTechnicianFormGroup">
      <div class="grid">
        <span class="flex-1 column-height">
          <div class="w-h-label html-overflow">
            {{
              "technicianNotification.label.notificationInterval" | translate
            }}
          </div>
          <lib-w-h-dropdown
            [itemKeys]="['displayName']"
            [subItemKey]="'subItem'"
            [loading]="remindTechnicianFormGroup.disabled"
            [value]="'value'"
            (onDomEvent)="setNotificationTime($event)"
            [valueFormControl]="
              remindTechnicianFormGroup.get('reminderOffsetInMinutes')
            "
            [dropdownItemDomList]="alertOptions"
          >
          </lib-w-h-dropdown>
        </span>

        <span class="flex-1 column-height">
          <div class="w-h-label header-margin html-overflow">
            {{ "technicianNotification.label.notificationTime" | translate }}
          </div>

          <div>
            {{ notificationTime() | date: "short" : "" : currentLocale }}
          </div>
        </span>

        <span class="flex-1 column-height">
          <div class="w-h-label header-margin html-overflow">
            {{ "workorder.model.scheduledstartdate" | translate }}
          </div>
          <div>
            {{ data.scheduledStartDate | date: "short" : "" : currentLocale }}
          </div>
        </span>
      </div>

      <mat-form-field>
        <mat-label>{{
          "workobject.model.contactclient.comment" | translate
        }}</mat-label>

        <textarea [rows]="3" matInput formControlName="reminderComment">
        </textarea>
      </mat-form-field>
    </form>
  </div>
  <w-h-button-group align="end" mat-dialog-actions>
    @if (
      (data.reminderOffsetInMinutes || data.reminderOffsetInMinutes === 0) &&
      !data.hideDeleteButton
    ) {
      <w-h-button
        [text]="'app.delete.label' | translate | uppercase"
        matIcon="delete"
        type="flat"
        [mat-dialog-close]="{
          reminderOffsetInMinutes: null,
          reminderComment: null,
        }"
      />
    }
    <w-h-button
      [text]="'app.cancel.label' | translate | uppercase"
      matIcon="close"
      type="flat"
      mat-dialog-close
    />
    <w-h-button
      [text]="'app.save.label' | translate | uppercase"
      matIcon="save"
      color="accent"
      type="flat"
      [disabled]="
        remindTechnicianFormGroup.disabled ||
        remindTechnicianFormGroup.invalid ||
        data.showNoneMessage
      "
      [mat-dialog-close]="remindTechnicianFormGroup.value"
    />
  </w-h-button-group>
</section>
